import { createSelector } from 'reselect'

import RootState from '../types'
import FiltersState from './types'
import FiltersConfigurationTransport from '../../transports/filters-configuration-transport'
import { FilterModalType, FilterType } from '../../components/app-components/filter-sort-section/types'
import SortOptionTransport from '../../transports/common/sort-option-transport'

const _getFiltersState = (state: RootState) => state.filters

export const getFiltersConfiguration = createSelector<RootState, FiltersState, FiltersConfigurationTransport | null>(
    _getFiltersState,
    filters => filters.filtersConfigurationResponse,
)

export const getCommittedFiltersConfiguration = createSelector<
    RootState,
    FiltersState,
    FiltersConfigurationTransport | null
>(_getFiltersState, filters => filters.committedFiltersConfigurationResponse)

export const getFilterError = createSelector<RootState, FiltersState, Error | null>(
    _getFiltersState,
    filters => filters.error,
)

export const getIsFilterLoading = createSelector<RootState, FiltersState, boolean>(
    _getFiltersState,
    filters => filters.isLoading,
)

export const getIsFilterBlocking = createSelector<RootState, FiltersState, boolean>(
    _getFiltersState,
    filters => filters.isBlocking,
)

export const getObjectCount = createSelector<RootState, FiltersState, number>(
    _getFiltersState,
    filters => filters.filtersConfigurationResponse?.objectCount ?? 0,
)

export const getRegionNodeId = createSelector<RootState, FiltersState, number>(
    _getFiltersState,
    filters => filters.regionNodeId,
)

export const getCurrentOpenedFilterModal = createSelector<RootState, FiltersState, FilterModalType | FilterType>(
    _getFiltersState,
    filters => filters.currentOpenedFilterModal,
)

export const getLastDataPathEncoded = createSelector<RootState, FiltersState, string>(
    _getFiltersState,
    filters => filters.lastDataPathEncoded,
)

export const getIsSpaMode = createSelector<RootState, FiltersState, boolean>(
    _getFiltersState,
    filters => filters.spaMode,
)

export const getSortOptions = createSelector<RootState, FiltersState, SortOptionTransport[] | null>(
    _getFiltersState,
    filters => filters.filtersConfigurationResponse?.sort || null,
)

export const getIsCancellationPolicyModalOpen = createSelector<RootState, FiltersState, boolean>(
    _getFiltersState,
    filters => filters.isCancellationPolicyModalOpen,
)
